import React, { useContext } from "react";
import ErrorResources from "../../../Components/ErrorResources";
import LocalizationContext from "../../../Localization/LanguageContext";
import { ILocalizationContext } from "../../../Localization/Models/ILocalizationContext";
import { LandingPage } from "../../../Components/LandingPage/LandingPage";

const NotFound = () => {
  const { getValue } = useContext(LocalizationContext) as ILocalizationContext;
  return (
    <LandingPage
      iconProps={{ icon: "search", size: "xxl"}}
      headingProps={{
        center: true,
        children: getValue("NotFound", "TitleSub"),
      }}
      description={<ErrorResources />}
    />
  );
};

export default NotFound;
